'use client';

import Image from 'next/image';
import Link from 'next/link';
import { Button } from './ui/button';
import { ScrollReveal } from './ScrollReveal';

export function SpeakingSection() {
  return (
    <section className="bg-background" id="speaking">
      {/* Speaking Section - Full width immersive with dark overlay */}
      <div className="relative min-h-[600px] lg:min-h-[700px] overflow-hidden">
        {/* Background image */}
        <Image
          src="/speaking.jpg"
          alt="Andrew McCourt speaking at an event"
          fill
          className="object-cover"
          sizes="100vw"
        />

        {/* Gradient overlays for depth */}
        <div className="absolute inset-0 bg-gradient-to-r from-primary/95 via-primary/80 to-primary/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-transparent to-primary/20" />

        {/* Decorative elements */}
        <div className="absolute top-12 right-12 w-32 h-32 border border-white/10 rotate-45 hidden lg:block" />
        <div className="absolute bottom-24 left-24 w-16 h-16 border border-accent/20 rotate-12 hidden lg:block" />

        {/* Content */}
        <div className="relative z-10 h-full min-h-[600px] lg:min-h-[700px] flex items-center">
          <div className="max-w-7xl mx-auto px-6 lg:px-8 w-full">
            <div className="max-w-2xl">
              <ScrollReveal>
                <span className="inline-flex items-center gap-2 text-sm font-medium tracking-wider uppercase text-white/60 mb-6">
                  <span className="w-6 h-px bg-accent/70" />
                  Speaking
                </span>
              </ScrollReveal>

              <ScrollReveal delay={100}>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white mb-6">
                  Invite Andrew<br />to Speak
                </h2>
              </ScrollReveal>

              <ScrollReveal delay={200}>
                <p className="text-lg lg:text-xl text-white/80 leading-relaxed mb-8 max-w-xl">
                  Looking for a speaker who brings both practical wisdom and spiritual depth?
                  Andrew delivers engaging messages that inspire action and create lasting impact
                  for conferences, churches, and organizations.
                </p>
              </ScrollReveal>

              <ScrollReveal delay={300}>
                <div className="flex flex-col sm:flex-row gap-4">
                  <Button
                    asChild
                    size="lg"
                    className="group h-14 px-8 bg-accent hover:bg-accent/90 text-white font-medium transition-all duration-300 hover:shadow-lg hover:shadow-accent/25"
                  >
                    <Link href="/speaking" className="flex items-center gap-2">
                      Request Speaking Engagement
                      <svg
                        className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </Link>
                  </Button>
                </div>
              </ScrollReveal>

              {/* Stats or social proof */}
              <ScrollReveal delay={400}>
                <div className="mt-12 pt-8 border-t border-white/10 flex flex-wrap gap-8">
                  <div>
                    <p className="text-3xl font-bold text-accent">30+</p>
                    <p className="text-sm text-white/60 uppercase tracking-wider">Years Ministry</p>
                  </div>
                  <div>
                    <p className="text-3xl font-bold text-accent">100s</p>
                    <p className="text-sm text-white/60 uppercase tracking-wider">Events Worldwide</p>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
